export const profile = {
communicationPrefs: {
screenTitle: "Kommunikationseinstellungen",
screenSubtitle: "Wählen Sie, worüber wir Sie kontaktieren. Erforderliche Benachrichtigungen braucht der Dienst, um sicher zu funktionieren; optionale liegen ganz bei Ihnen.",
requiredSectionTitle: "Erforderlich",
requiredSectionHint: "Wird per E-Mail und/oder Push gesendet. Erforderlich für die sichere Verwendung von AssetWRX.",
requiredBadge: "Erforderlich",
optionalSectionTitle: "Optional",
optionalSectionHintLoading: "Ihre Einstellungen werden geladen…",
optionalSectionHint: "Schalten Sie die einzelnen Funktionen jederzeit ein oder aus. Der Widerruf wird sofort wirksam und in Ihrem Einwilligungsverlauf protokolliert.",
alwaysOnBadge: "Immer an",
alwaysOnHintLegit: "Immer an (für einen sicheren Betrieb nötig)",
marketingEmailTitle: "Produktaktualisierungen, Tipps und Werbeaktionen – E-Mail",
marketingEmailBody: "Gelegentliche E-Mails über neue Funktionen, Workflow-Muster und Angebote. Standardmäßig deaktiviert.",
marketingPushTitle: "Produktaktualisierungen, Tipps und Werbeaktionen – Push",
marketingPushBody: "Push-Benachrichtigungen für wichtige Produkteinführungen und Angebote. Standardmäßig deaktiviert.",
analyticsTitle: "Produktanalyse",
analyticsBody: "Helfen Sie uns zu verstehen, wie AssetWRX verwendet wird, damit wir es verbessern können: genutzte Bildschirme, Tippaktionen und Sitzungsaufzeichnungen, in denen alles, was Sie eingeben, verborgen ist.",
crashReportingTitle: "Absturz- und Stabilitätsberichte",
crashReportingBody: "Absturzberichte ohne Ihre persönlichen Angaben. Immer an, weil wir sie brauchen, damit AssetWRX funktioniert.",
serviceNotifTitle: "Servicebenachrichtigungen",
serviceNotifBody: "Vorfallwarnungen, Rechnungsbelege und Kontoänderungen.",
securityNotifTitle: "Sicherheitsbenachrichtigungen",
securityNotifBody: "Anmeldewarnungen, Passwortänderungen, Warnungen vor verdächtigen Aktivitäten.",
inspectionRemindersTitle: "Inspektionserinnerungen",
inspectionRemindersBody: "Erinnerungen an geplante Inspektionen, für die Sie zuständig sind.",
confirmEmailError: "Bestätigungs-E-Mail konnte nicht gesendet werden. Versuchen Sie es erneut.",
alreadySubscribed: "Sie sind bereits abonniert.",
confirmationSent: "Überprüfen Sie Ihre E-Mails – wir haben einen Bestätigungslink gesendet. Klicken Sie innerhalb von 24 Stunden darauf, um sich anzumelden.",
updatedFeedback: "{{title}} aktualisiert.",
saveError: "Ihre Präferenz konnte nicht gespeichert werden. Versuchen Sie es erneut.",
pendingHint: "Ausstehend – überprüfen Sie Ihre E-Mail auf den Bestätigungslink (gültig 24 Stunden).",
deliveryPausedHint: "Das Abonnement wurde aufgrund von Zustellproblemen pausiert. Schalten Sie die Option aus und wieder ein, um es erneut zu versuchen.",
},
consentHistory: {
loading: "Wird geladen…",
errorTitle: "Fehler",
emptyTitle: "Noch keine Einwilligungsereignisse",
emptyBody: "Sobald Sie eine Präferenz akzeptiert oder geändert haben, wird sie hier angezeigt.",
screenTitle: "Einwilligungshistorie",
screenSubtitle: "Jede Richtlinie, die Sie akzeptiert haben, und jede Marketing- oder Analyse-Entscheidung, die Sie getroffen oder zurückgenommen haben. Einträge bleiben unverändert und können nicht geändert werden. Telefon-Hinweise sind keine Einwilligungen und liegen unter Einstellungen.",
labelTerms: "Nutzungsbedingungen",
labelPrivacy: "Datenschutzrichtlinie",
labelMarketingEmail: "Marketing-E-Mail",
labelMarketingPush: "Marketing-Push",
labelAnalytics: "Produktanalyse",
labelCrashReporting: "Absturzmeldung",
labelCookieAnalytics: "Analytics-Cookies",
labelCookieMarketing: "Marketing-Cookies",
labelLocationSharing: "Standortfreigabe während der Arbeit",
actionAccepted: "akzeptiert",
actionWithdrawn: "zurückgezogen",
actionUpdated: "aktualisiert",
detailSource: "Erteilt über",
detailReason: "Grund",
sourcePhonePrompt: "Die Analysefrage der App",
sourceSignup: "Registrierung",
sourceCookieBanner: "Cookie-Banner",
sourceSignupCatchup: "Registrierung (später erfasst)",
device: {
ios: "iPhone oder iPad",
android: "Android-Gerät",
web: "Webbrowser",
unknown: "Unbekanntes Gerät",
},
},
exportData: {
whatYoullReceiveTitle: "Was Sie erhalten",
itemProfile: "Ihre Profil- und Kontoeinstellungen",
itemAssets: "Alle Anlagen, Inspektionen und Arbeitsaufträge, die Sie besitzen",
itemContacts: "Kontakte und Teammitgliedschaften",
itemRequests: "Von Ihnen gestellte Anfragen und jede Nachricht dazu",
itemReports: "Mit Ihnen geteilte Berichte und Angebote, mit Ihren Antworten",
itemConsent: "Ihr vollständiger Einwilligungs- und Prüfverlauf",
itemDeletionLog: "Protokolleinträge zur Kontolöschung (falls vorhanden)",
itemPriorExports: "Eine Kopie aller vorherigen Exportanfragen",
footnote: "Jeder Download-Link funktioniert 7 Tage lang und nur für Sie.",
preparing: "Vorbereiten Ihres Exports…",
requestButton: "Meinen Datenexport anfordern",
recentRequestsTitle: "Aktuelle Anfragen",
loading: "Wird geladen…",
noExportsYet: "Noch keine Exporte – fordern Sie oben einen an, um loszulegen.",
statusQueued: "In der Warteschlange",
statusProcessing: "Verarbeitung",
statusReady: "Bereit",
statusFailed: "Fehlgeschlagen",
statusExpired: "Abgelaufen",
requestedAt: "Angefordert {{date}}",
linkExpires: "Link läuft ab {{date}}",
linkExpiresSoon: "Läuft innerhalb von 24 Stunden ab · Link läuft ab {{date}}",
downloadButton: "Herunterladen",
readyFeedback: "Ihr Export ist fertig. Tippen Sie unten auf „Herunterladen“, um ihn zu speichern.",
screenTitle: "Meine Daten exportieren",
screenSubtitle: "Sie können jederzeit eine Kopie Ihrer AssetWRX-Kontodaten herunterladen. Sie erhalten eine Datendatei, die andere Programme öffnen können.",
},
privacyDataHub: {
screenTitle: "Datenschutz & Daten",
screenSubtitle: "Laden Sie Ihre Daten herunter, wählen Sie, was wir Ihnen mailen, oder löschen Sie Ihr Konto. Jede Änderung wird in Ihrem Einwilligungsverlauf festgehalten.",
expandLabel: "Öffnen",
collapseLabel: "Schließen",
itemPrivacyTitle: "Datenschutzrichtlinie",
itemPrivacyBody: "Wie wir Ihre Daten erfassen, verwenden und schützen.",
itemTermsTitle: "Nutzungsbedingungen",
itemTermsBody: "Die Vereinbarung, die Ihre Nutzung von AssetWRX regelt.",
itemCookiesTitle: "Cookie-Richtlinie",
itemCookiesBody: "Welche Cookies und ähnliche Speicher wir verwenden und wie Sie sie steuern können.",
itemSubprocessorsTitle: "Unterprozessoren",
itemSubprocessorsBody: "Die Dritten, die wir mit der Datenverarbeitung beauftragen, und der Ort, an dem sie tätig sind.",
itemDpaTitle: "Datenverarbeitungsvereinbarung",
itemDpaBody: "Wie wir Ihre Inhalte in Ihrem Auftrag verarbeiten.",
itemMarketingTitle: "Marketing-Einwilligungsrichtlinie",
itemMarketingBody: "Wie wir Ihr Opt-in einholen, nachweisen und respektieren.",
itemExportTitle: "Meine Daten exportieren",
itemExportBody: "Laden Sie eine Kopie aller Daten Ihres Kontos herunter.",
itemCommsTitle: "Kommunikationseinstellungen",
itemCommsBody: "Wählen Sie, welche optionalen Updates und Tipps Sie erhalten und auf welchen Kanälen.",
itemHistoryTitle: "Einwilligungshistorie",
itemHistoryBody: "Jede Richtlinie, die Sie akzeptiert haben, und jede Marketing- oder Analyseeinwilligung, die Sie erteilt oder widerrufen haben.",
itemAiTitle: "KI-Funktionen",
itemAiBody: "Ob AssetWRX Fotos und Text an Google (Gemini) senden darf, wenn Sie auf diesem Gerät eine KI-Funktion nutzen.",
aiAllowed: "Auf diesem Gerät erlaubt. Google verarbeitet, was eine KI-Funktion sendet, und nutzt es nicht zum Training seiner Modelle.",
aiNotAllowed: "Nicht erlaubt. KI-Funktionen fragen, bevor sie etwas senden.",
aiWithdraw: "KI auf diesem Gerät nicht mehr nutzen",
aiAllow: "KI-Funktionen erlauben",
itemDeletionPolicyTitle: "Richtlinie zur Datenlöschung",
itemDeletionPolicyBody: "Wie das Löschen funktioniert, was beibehalten wird und das 30-tägige Wiederherstellungsfenster.",
itemDeleteTitle: "Konto löschen",
itemDeleteBody: "Löschen Sie Ihr Konto und Ihre Daten unwiderruflich. Es gilt ein 30-tägiges Wiederherstellungsfenster.",
},
security: {
  twoFactorSection: "Zwei-Faktor-Anmeldung",
  signIn: {
    cancel: "Abbrechen",
    biometricOffHint: "Aus. Die gespeicherte Anmeldung auf diesem Telefon wird gelöscht.",
    biometricOnHint: "An. {{method}} meldet Sie auf diesem Telefon an (nach einer Anmeldung mit Ihrem Passwort).",
    biometricTitle: "Auf diesem Telefon mit {{method}} anmelden",
    setPasswordFailed: "Der Link wurde nicht gesendet. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    setPasswordSent: "Wir haben einen Link an {{email}} gesendet. Öffnen Sie ihn, um Ihr Passwort festzulegen. Sie können sich weiterhin mit Google, Apple oder Microsoft anmelden.",
    passwordChanged: "Ihr Passwort ist geändert. Verwenden Sie es bei der nächsten Anmeldung.",
    passwordFailed: "Ihr Passwort wurde nicht geändert. Versuchen Sie es erneut.",
    passwordMismatch: "Die beiden Passwörter sind unterschiedlich. Geben Sie zweimal dasselbe ein.",
    passwordRequired: "Geben Sie ein neues Passwort ein.",
    passwordSave: "Passwort speichern",
    passwordConfirmLabel: "Noch einmal eingeben",
    passwordNewLabel: "Neues Passwort",
    setPassword: "Passwort festlegen",
    passwordChange: "Passwort ändern",
    passwordNone: "Sie melden sich mit Google, Apple oder Microsoft an, daher gibt es noch kein Passwort.",
    passwordSet: "Sie melden sich mit einem Passwort an.",
    passwordTitle: "Passwort",
    emailSent: "Wir haben einen Link an Ihre neue Adresse {{email}} gesendet. Öffnen Sie ihn, um die Änderung abzuschließen. Bis dahin melden Sie sich weiter mit {{current}} an.",
    emailFailed: "Der Link wurde nicht gesendet. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    emailTaken: "Ein anderes Konto verwendet diese Adresse bereits. Verwenden Sie eine andere.",
    emailSame: "Das ist bereits Ihre E-Mail-Adresse.",
    emailInvalid: "Geben Sie eine E-Mail-Adresse wie name@firma.de ein.",
    emailSend: "Link senden",
    emailNewHelper: "Wir senden einen Link an die neue Adresse. Die Änderung erfolgt, wenn Sie ihn öffnen.",
    emailNewLabel: "Neue E-Mail-Adresse",
    emailPending: "Wartet darauf, dass Sie den an {{email}} gesendeten Link öffnen.",
    emailChange: "E-Mail ändern",
    emailTitle: "E-Mail",
    sectionTitle: "So melden Sie sich an",
  },
title: "Sicherheit",
removeLastWarning: "Dies ist Ihr einziger Authentifikator. Die Zwei-Faktor-Anmeldung ist Pflicht, daher werden Sie sofort aufgefordert, wieder einen einzurichten.",
removeBody: "Diesen Authentifikator entfernen? Sie können ihn später erneut hinzufügen.",
removeTitle: "Authentifikator entfernen",
cancel: "Abbrechen",
remove: "Entfernen",
removeFailedTitle: "Konnte nicht entfernt werden",
removeFailedBody: "Bitte erneut versuchen.",
statusOn: "Die Zwei-Faktor-Anmeldung ist aktiviert",
statusOff: "Die Zwei-Faktor-Anmeldung ist deaktiviert",
statusSub: "Schützt Ihr Konto mit einem Code aus einer Authentifizierungs-App (Microsoft Authenticator, Google Authenticator, Authy).",
methods: "Ihre Authentifikatoren",
loading: "Wird geladen…",
none: "Noch kein Authentifikator eingerichtet.",
authenticator: "Authentifikator",
added: "Hinzugefügt",
removeA11y: "Authentifikator entfernen",
add: "Fügen Sie einen Authentifikator hinzu",
addBackup: "Fügen Sie einen Backup-Authentifikator hinzu",
},
diagnosticsScreen: {
  title: "Diagnose",
  subtitle: "Was der Support wissen muss. Nichts hiervon ist geheim.",
  sectionBuild: "Build",
  sectionWorkspace: "Arbeitsbereich",
  sectionConnectivity: "Verbindung",
  sectionServices: "Dienste",
  appVersion: "App-Version",
  build: "Build",
  commit: "Git-Commit",
  runtime: "Runtime-Version",
  updateChannel: "Update-Kanal",
  platform: "Plattform",
  environment: "Umgebung",
  backend: "Backend",
  workspace: "Arbeitsbereich",
  role: "Rolle",
  plan: "Tarif",
  capabilities: "Aktive Funktionen",
  connectivity: "Verbindung",
  online: "Online",
  offline: "Offline",
  outbox: "Änderungen, die auf Senden warten",
  lastSync: "Zuletzt gesendet",
  sentry: "Absturzberichte",
  sentryOn: "Aktiv · Release {{release}}",
  sentryOff: "Nicht konfiguriert",
  posthog: "Produktanalyse",
  posthogOn: "Aktiv (Einwilligung erteilt)",
  posthogOff: "Aus (keine Einwilligung)",
  apiHealth: "API-Status",
  apiChecking: "Wird geprüft…",
  apiOk: "OK · {{latency}} ms · Migrationen {{head}}",
  apiFail: "Nicht erreichbar",
  push: "Push-Benachrichtigungen",
  pushRegistered: "Beim Expo-Push-Dienst registriert",
  pushNotRegistered: "Auf diesem Gerät nicht registriert (erfordert einen Build mit Push-Zugangsdaten und erteilter Berechtigung)",
  pushUnsupported: "Auf dieser Plattform nicht verfügbar",
  copy: "Diagnose kopieren",
  copied: "Kopiert",
  never: "Nie",
  unknown: "Unbekannt",
  personal: "Persönlich",
  none: "Keine",
  web: "Web",
},
whatsNew: {
  eyebrow: "Neuigkeiten in AssetWRX",
  gotIt: "Verstanden",
  seeAll: "Alle Updates ansehen",
  sectionTitle: "Neuigkeiten",
  empty: "Noch keine Versionshinweise.",
  dateLine: "Version {{version}} vom {{date}}",
},
aboutScreen: {
  product: "AssetWRX {{version}}",
  title: "Info",
  subtitle: "Die AssetWRX-Version auf diesem Gerät. Kopieren Sie sie, wenn Sie den Support kontaktieren.",
  build: "Build {{build}}",
  webBuild: "Web",
  runtime: "Runtime {{runtime}}",
  channel: "Kanal {{channel}}",
  environment: "Umgebung {{environment}}",
  update: "Update {{update}}",
  copy: "Kopieren",
  copied: "Kopiert",
},
helpScreen: {
  contactSupportSubtitle: "Fragen Sie einen Menschen. Öffnet unsere Support-Seite im Browser.",
  contactSupportTitle: "AssetWRX-Support kontaktieren",
subtitle: "Mit AssetWRX können Sie Anlagen verwalten, Inspektionen durchführen und Reparaturaufträge verfolgen.",
coreWorkflowTitle: "Kern-Workflow",
coreWorkflowBody: "• Anlagen hinzufügen (Fahrzeuge, Ausrüstung, Immobilien)\n• Eine Inspektion mit einer Checkliste starten\n• Den Bericht zur Genehmigung an den Kunden senden\n• Genehmigte Reparaturen in Arbeitsaufträge umwandeln\n• Arbeitsaufträge Teammitgliedern oder Auftragnehmern zuweisen",
toursTitle: "Geführte Touren",
toursSubtitle: "Schritt-für-Schritt-Anleitungen in der App: Anlage anlegen, Inspektion durchführen, Wartung einrichten.",
openToursA11y: "Geführte Touren öffnen",
guideTitle: "Benutzerhandbuch",
guideSubtitle: "Schritt-für-Schritt-Anleitungen für jeden Teil von AssetWRX.",
openGuideA11y: "Öffnen Sie das Benutzerhandbuch",
},
pushNotificationPrefs: {
  productTitle: "Produkt-Neuigkeiten",
  productBody: "Antworten auf Ihre Funktionswünsche und Neues zu Ideen, für die Sie gestimmt haben.",
  saveFailed: "Diese Einstellung wurde nicht gespeichert. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  permission: {
    onBody: "Wählen Sie unten, welche Hinweise Sie erreichen.",
    onTitle: "Benachrichtigungen sind auf diesem Telefon an",
    openSettings: "Einstellungen öffnen",
    blockedBody: "Dieses Telefon erlaubt AssetWRX keine Hinweise. Schalten Sie sie in den Einstellungen des Telefons ein und kommen Sie dann zurück.",
    blockedTitle: "Benachrichtigungen für AssetWRX sind aus",
    askAction: "Benachrichtigungen einschalten",
    askBody: "Wir melden uns, wenn Ihnen Arbeit zugewiesen wird, jemand antwortet oder etwas auf Ihre Entscheidung wartet. Ihr Telefon fragt Sie nach der Erlaubnis.",
    askTitle: "Hinweise auf diesem Telefon erhalten",
  },
assignmentTitle: "Mir zugewiesen",
assignmentBody: "Ihnen zugewiesene Arbeitsaufträge und Inspektionen, Einladungen von Auftragnehmern und vergebene Arbeiten.",
messageTitle: "Nachrichten",
messageBody: "Antworten auf Arbeitsaufträge, mit Ihnen geteilte Berichte und Ihre Asset-360- und Site-360-Berichte, sobald sie fertig sind.",
approvalTitle: "Genehmigungen und Anfragen",
approvalBody: "Neue Anfragen, eingereichte Angebote, Abschlüsse und Anfragen zum Berichtszugriff, die auf Ihre Entscheidung warten.",
cardTitle: "Push-Benachrichtigungen",
hintUnsupported: "Push-Benachrichtigungen werden an die mobile App AssetWRX übermittelt. Diese Einstellungen gelten für Ihr Telefon.",
hintLoading: "Ihre Einstellungen werden geladen…",
hintDefault: "Wählen Sie, was Ihr Telefon erreicht. In beiden Fällen erscheint weiterhin alles in Ihrem In-App-Posteingang.",
saveError: "Konnte nicht gespeichert werden: {{error}}",
quietHoursTitle: "Ruhezeiten",
quietHoursBody: "In diesem Zeitraum wird nichts per Push gesendet. Benachrichtigungen kommen weiterhin in Ihrem In-App-Posteingang{{suffix}} an.",
fromLabel: "Von",
toLabel: "Bis",
androidChannelNote: "Jede Kategorie verfügt über einen eigenen Android-Benachrichtigungskanal, sodass Sie in den Systemeinstellungen auch den Ton und die Priorität pro Kategorie anpassen können.",
},
personal: {
notSet: "Nicht gesetzt",
personalMode: "Persönlicher Modus",
roleInCurrentContext: "Rolle im aktuellen Kontext",
roleUnavailable: "Rolle nicht verfügbar",
languageNotSet: "Nicht festgelegt (Standard des Arbeitsbereichs, dann Gerät)",
timezoneNotSet: "Nicht festgelegt (Standard des Arbeitsbereichs, dann Gerät)",
languageHelper: "Leer lassen für den Standard des Arbeitsbereichs, dann die Gerätesprache, falls unterstützt, dann Englisch (US).",
timezoneHelper: "Leer lassen für die Standardzeitzone des Arbeitsbereichs, dann die Gerätezeitzone, dann UTC.",
effectiveLanguage: "Verwendete Sprache",
effectiveTimezone: "Verwendete Zeitzone",
localeMoved: "Sprache und Zeitzone finden Sie unter Einstellungen",
localeMovedA11y: "Einstellungen öffnen, um Sprache und Zeitzone zu ändern",
sectionTitle: "Persönliche Angaben",
sectionSubtitle: "Name, Kontakt und Kurzinfo.",
photoTitle: "Profilfoto",
photoSubtitle: "Ihr Foto erscheint in der Navigationsleiste, in Teamansichten und in Aktivitäten. Es ist unabhängig von Arbeitsbereichs- oder Berichtslogos.",
edit: "Bearbeiten",
fullName: "Vollständiger Name",
displayName: "Anzeigename",
phone: "Telefon",
language: "Sprache",
timezone: "Zeitzone",
email: "E-Mail",
bio: "Über mich",
shortBio: "Kurzbeschreibung",
editTitle: "Profil bearbeiten",
fieldDisplayName: "Anzeigename",
placeholderDisplayName: "So soll Ihr Name angezeigt werden",
fieldFirstName: "Vorname",
placeholderFirstName: "Vorname",
fieldLastName: "Nachname",
placeholderLastName: "Nachname",
fieldJobTitle: "Berufsbezeichnung",
placeholderJobTitle: "Berufsbezeichnung",
langA11y: "Sprache",
tzA11y: "Zeitzone",
bioPlaceholder: "Kurze Beschreibung für Ihr Profil",
emailReadOnlyHint: "Um Ihre E-Mail zu ändern, gehen Sie zu Konto → Sicherheit.",
cancel: "Abbrechen",
saveProfile: "Profil speichern",
pickerLanguageTitle: "Sprache",
pickerTimezoneTitle: "Zeitzone",
searchLanguage: "Sprache oder Code suchen",
searchTimezone: "Zeitzone suchen",
errorInvalidPhone: "Bitte geben Sie eine gültige Telefonnummer ein.",
saveSuccessTitle: "Gespeichert",
saveSuccessBody: "Ihr Profil wurde aktualisiert.",
saveErrorGeneric: "Profil konnte nicht gespeichert werden.",
phoneNumberLabel: "Telefonnummer",
countryCallingCodeA11y: "Ländervorwahl",
countryCallingCodeHint: "Öffnet die Länderliste",
nationalNumberPlaceholder: "Rufnummer ohne Vorwahl",
nationalNumberA11y: "Telefonnummer ohne Vorwahl",
countryRegionTitle: "Land oder Region",
searchCountry: "Land oder Code suchen",
},
overview: {
  tileIndustryPacksSubtitle: "Fertige Anlagentypen, Checklisten und Pläne",
  tileIndustryPacksTitle: "Branchenpakete",
  tileAssetTypesTitle: "Anlagentypen",
  tileAssetTypesSubtitle: "Eigene Arten von Anlagen und Orten und die Angaben, die jede verlangt",
changePhoto: "Foto ändern",
uploadPhoto: "Foto hochladen",
remove: "Entfernen",
noJobTitle: "Noch keine Berufsbezeichnung",
profileCompleteness: "Profilvollständigkeit",
memberSince: "Mitglied seit",
recentMember: "Kürzlich beigetreten",
moreSection: "Mehr",
moreSubtitle: "Arbeitsbereich, Ihre Einstellungen und Sitzung.",
personalSection: "Persönlich",
workspaceSection: "Arbeitsbereich",
sessionSection: "Sitzung",
workspace: "Arbeitsbereich",
workspaceSubtitle: "Kontext, Standardwerte und Berichts-Branding.",
preferences: "Einstellungen",
help: "Hilfe",
securitySection: "Sicherheit & Datenschutz",
privacyData: "Datenschutz & Daten",
consentHistory: "Einwilligungsverlauf",
exportData: "Meine Daten exportieren",
deleteAccount: "Konto löschen",
signOut: "Abmelden",
signOutTitle: "Abmelden",
signOutConfirm: "Möchten Sie sich wirklich abmelden?",
signOutCancel: "Abbrechen",
signOutAction: "Abmelden",
signOutPendingNote: "Ihre ausstehenden Arbeiten bleiben auf diesem Gerät, wenn Sie sich abmelden. Sie können die Synchronisierung überprüfen und etwaige Fehler beheben, bevor Sie das Programm verlassen.",
reviewPendingWrites: "Noch nicht übertragene Änderungen prüfen",
signOutErrorTitle: "Die Abmeldung konnte nicht abgeschlossen werden",
signOutErrorBody: "Ihre gespeicherten Änderungen wurden beibehalten. Bitte versuchen Sie es erneut.",
workspaceTypeMember: "Mitglied",
workspaceTypeContractor: "Auftragnehmer",
workspaceTypeRecipient: "Empfänger",
teamsCount_one: "{{count}} Team",
teamsCount_other: "{{count}} Teams",
kpiUsersLabel: "Benutzer",
kpiUsersHint: "In diesem Arbeitsbereich",
kpiAssetsLabel: "Anlagen",
kpiAssetsHint: "Arbeitsbereich insgesamt",
kpiInspectionsLabel: "Inspektionen",
kpiInspectionsHint: "Alle Datensätze",
kpiJobsLabel: "Aufträge",
kpiJobsOpenHint_one: "{{count}} offen",
kpiJobsOpenHint_other: "{{count}} offen",
kpiCreditsLabel: "KI-Credits",
kpiCreditsHint: "Verfügbares Guthaben",
creditsUnlimited: "Unbegrenzt",
groupSettingsA11y_one: "{{title}}, {{count}} Einstellung. {{action}}.",
groupSettingsA11y_other: "{{title}}, {{count}} Einstellungen. {{action}}.",
groupExpandAction: "Erweitern",
groupCollapseAction: "Einklappen",
groupYouTitle: "Sie",
groupPlanTitle: "Tarif und Werkzeuge",
tileOrganizationTitle: "Organisation",
tileOrganizationSubtitleAdmin: "Logo des Arbeitsbereichs, Firmenprofil und rechtliche Details",
tileOrganizationSubtitleMember: "Sehen Sie sich das Logo des Arbeitsbereichs, das Firmenprofil und rechtliche Details an",
tileTeamsTitle: "Teams und Einladungen",
tileTeamsSubtitleAdmin: "Mitglieder des Arbeitsbereichs, Rollen und Einladungen",
tileTeamsSubtitleMember: "Mitglieder des Arbeitsbereichs, Rollen und Ihre Einladungen ansehen",
tileDefaultsTitle: "Regionale Standardeinstellungen",
tileDefaultsSubtitle: "Währung, Sprache, Zeitzone und Freigabemethoden",
tileBrandingTitle: "Berichts-Branding",
tileBrandingSubtitleAdmin: "PDF/Share-Logo und Exportdetails (getrennt vom Arbeitsbereich)",
tileBrandingSubtitleMember: "Sehen Sie sich das PDF/share-Logo und die Exportdetails an",
tileIntegrationsTitle: "Integrationen",
tileIntegrationsSubtitle: "Andere Systeme verbinden und Daten übernehmen",
tileTemplatesTitle: "Checklisten",
tileTemplatesSubtitle: "Inspektions- und Arbeitsauftragspläne",
tileAiTitle: "KI",
tileAiSubtitle: "Nutzung, Automatisierungen, Audit",
tileAssistantActivityTitle: "Assistent-Aktivität",
tileAssistantActivitySubtitle: "Änderungen über den Assistenten",
tileYourPlanTitle: "Tarif {{plan}}",
tileYourPlanTitleLimit_one: "Tarif {{plan}} · {{owned}} von {{count}} Anlage",
tileYourPlanTitleLimit_other: "Tarif {{plan}} · {{owned}} von {{count}} Anlagen",
tileYourPlanTitleUnknown: "Ihr Tarif",
tileYourPlanSubtitle: "Tarife und ihren Umfang ansehen",
tileBillingTitle: "Abrechnung",
tileBillingSubtitleAdmin: "Tarif, Credits, Rechnungen",
tileBillingSubtitleMember: "Tarif und Credit-Nutzung anzeigen",
tileGuideTitle: "Benutzerhandbuch",
tileGuideSubtitle: "Schritt-für-Schritt-Anleitungen für jeden Teil von AssetWRX",
tileProfileTitle: "Profil",
tileProfileSubtitle: "Name, Foto, Kontakt",
tilePreferencesSubtitle: "Sprache, Darstellung und Telefon-Hinweise",
tileSecurityTitle: "Sicherheit",
tileSecuritySubtitle: "E-Mail, Passwort und Zwei-Faktor",
tilePrivacyTitle: "Datenschutz",
tilePrivacySubtitle: "Ihre Daten, unsere E-Mails, Konto löschen",
tileFeaturesTitle: "Funktionen",
tileFeaturesSubtitle: "Was in diesem Arbeitsbereich aktiv, inaktiv oder gesperrt ist",
tileDiagnosticsTitle: "Diagnose",
tileDiagnosticsSubtitle: "Build-, Verbindungs- und Synchronisierungsstatus für den Support",
tileAboutTitle: "Info",
tileAboutSubtitle: "Version und Build",
groupAppTitle: "App",
tileHelpTitle: "Hilfe",
groupAdvancedTitle: "Erweitert",
tileNotificationsTitle: "Benachrichtigungen",
tileNotificationsSubtitle: "E-Mails und Push-Hinweise, die Sie erhalten",
tileBrandingDefaultsTitle: "Branding und Standardwerte",
tileBrandingDefaultsSubtitle: "Organisation, Berichts-Branding, regionale Standardwerte",
tileApiExplorerTitle: "API-Explorer",
tileApiExplorerSubtitle: "Die öffentliche API mit Ihren Schlüsseln testen",
tileHandbookTitle: "Integrationshandbuch",
tileHandbookSubtitle: "Anleitungen zum Verbinden und Automatisieren von AssetWRX",
tileHelpSubtitle: "Wie AssetWRX funktioniert und wo Sie Support erhalten",
},
tabs: {
summary: "Übersicht",
personal: "Persönlich",
profilePagesA11y: "Seiten der persönlichen Einstellungen",
},
accountScreen: {
title: "Kontoeinstellungen",
subtitleOverview: "Verwalten Sie Ihr Profil, Ihren Arbeitsbereich, die Abrechnung und Integrationen.",
subtitleOverviewPersonalOnly: "Ihr Profil, Ihre Einstellungen, Sicherheit und Datenschutz.",
subtitlePersonal: "Ihr Name, Ihre Kontaktdaten und Ihr Foto",
subtitleWorkspace: "Profil des Arbeitsbereichs, Team, Integrationen und Abrechnung",
},
accountScope: {
areasA11y: "Bereiche der Kontoeinstellungen",
userDetails: "Persönlich",
userDetailsHint: "Profil, Einstellungen und Hilfe",
userDetailsTabA11y: "Persönliche Einstellungen",
workspace: "Arbeitsbereich",
workspaceHint: "Organisation, Team und Verwaltung",
workspaceTabA11y: "Einstellungen des Arbeitsbereichs",
},
preferences: {
title: "Einstellungen",
subtitle: "Einstellungen, die nur für Sie gelten.",
localeTitle: "Sprache & Region",
localeHint: "Wie Datum, Uhrzeit und Text für Sie angezeigt werden. Diese Einstellungen sind an Ihr Konto gebunden und gelten auf jedem Gerät, auf dem Sie sich anmelden.",
localeLanguage: "Sprache",
localeTimezone: "Zeitzone",
localeLanguageA11y: "Sprache ändern",
localeTimezoneA11y: "Zeitzone ändern",
localeEffectiveLanguage: "Derzeit verwendet: {{value}}",
localeEffectiveTimezone: "Derzeit verwendet: {{value}}",
localeSaveError: "Ihre Sprache und Zeitzone konnten nicht gespeichert werden.",
notificationsTitle: "Benachrichtigungen",
pushNotifications: "Push-Benachrichtigungen",
pushNotificationsHint: "Aktivieren Sie Hinweise und Updates für Inspektionsprüfungen, Aufträge und Erinnerungen.",
haptics: "Haptisches Feedback",
hapticsHint: "Ein leichtes Tippen in der Hand, wenn Sie etwas abschließen, speichern oder auswählen.",
appearanceTitle: "Erscheinungsbild",
appearanceHint: "Legt fest, ob Bildschirme auf diesem Gerät helle oder dunkle Oberflächen verwenden. „An System anpassen“ folgt der Einstellung Ihres Telefons oder Computers.",
appearanceLight: "Hell",
appearanceDark: "Dunkel",
appearanceSystem: "An System anpassen",
densityComfy: "Komfortabel",
densityComfyHint: "Mehr Freiraum",
densityCompact: "Kompakt",
densityCompactHint: "Ausgewogen",
densityDense: "Dicht",
densityDenseHint: "Am meisten auf dem Bildschirm",
textSizeDefault: "Standard",
textSizeLarge: "Groß",
textSizeExtraLarge: "Sehr groß",
privacyTitle: "Datenschutz & Daten",
privacyHint: "Verwalten Sie Ihre persönlichen Daten und Ihr Konto.",
privacyOpenA11y: "Datenschutz & Daten öffnen",
deleteAccount: "Konto löschen",
deleteAccountHint: "Löschen Sie Ihr Konto und Ihre persönlichen Daten dauerhaft.",
textSizeTitle: "Textgröße",
textSizeHint: "Machen Sie den Text in der gesamten App leichter lesbar. Dies gilt überall und funktioniert zusammen mit der Textgrößeneinstellung Ihres Geräts.",
textSizeA11y: "Textgröße {{label}}",
densityTitle: "Anzeigedichte",
densityHint: "Wie viele Informationen auf jeden Bildschirm passen. Gilt überall.",
densityA11y: "Anzeigedichte {{label}}",
privacyDataTitle: "Datenschutz & Daten",
privacyDataHint: "Datenschutzrichtlinie, Bedingungen, Export, Kommunikationseinstellungen, Einwilligungsverlauf, Konto löschen",
},
deleteAccount: {
  ownerHandOver: "Inhaberschaft übertragen",
  ownerImpact: "Sie sind Inhaber dieses Arbeitsbereichs, und andere arbeiten darin. Sie verlieren den Zugriff, wenn Sie Ihr Konto löschen. Damit er ihnen bleibt, übertragen Sie die Inhaberschaft zuerst an jemand anderen.",
  contactSupport: "AssetWRX-Support kontaktieren",
warningTitle: "Dadurch wird Ihr Konto dauerhaft gelöscht",
warningBody: "Das Löschen Ihres Kontos ist unwiderruflich. Nach Ablauf der Wiederherstellungsfrist können Ihre Daten nicht wiederhergestellt werden.",
consequencesTitle: "Was gelöscht wird",
consInspections: "Alle von Ihnen erstellten Inspektionen und deren Berichte",
consAssets: "Ihre Anlagen und deren Verlauf",
consMedia: "Fotos, Dokumente und andere hochgeladene Medien",
consTeams: "Ihre Teammitgliedschaften und der Zugriff auf gemeinsame Arbeitsbereiche",
consBilling: "Aktive Abonnements werden gekündigt und die Abrechnung endet",
recoveryBody: "Ihre eigenen Arbeitsbereiche werden {{days}} Tage aufbewahrt und dann endgültig entfernt. Wenn Sie sie in dieser Zeit zurückhaben möchten, kontaktieren Sie den AssetWRX-Support. Ihre persönlichen Angaben werden sofort entfernt.",
offlineBanner: "Sie sind offline. Stellen Sie eine Internetverbindung her, um Ihr Konto zu löschen.",
confirmLabel: "Geben Sie {{token}} ein, um zu bestätigen",
confirmHelper: "Geben Sie {{token}} genau wie angezeigt ein, um die Schaltfläche zum Löschen zu aktivieren.",
passwordLabel: "Bestätigen Sie Ihr Passwort",
passwordHelper: "Erforderlich, wenn Sie sich mit einem Passwort anmelden. Leer lassen, wenn Sie sich mit Google, Apple oder Microsoft anmelden.",
passwordPlaceholder: "Ihr Passwort",
reauthError: "Bitte geben Sie Ihr Passwort erneut ein, um zu bestätigen, dass Sie es wirklich sind.",
genericError: "Die Kontolöschung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
deleteButton: "Mein Konto löschen",
deletingStatus: "Ihr Konto wird gelöscht…",
modalTitle: "Konto endgültig löschen?",
modalBody: "Dies kann nicht rückgängig gemacht werden. Ihre persönlichen Daten werden jetzt anonymisiert, und Arbeitsbereiche, die nur Ihnen gehören, werden nach der Wiederherstellungsfrist entfernt.",
modalConfirm: "Endgültig löschen",
modalCancel: "Konto behalten",
successTitle: "Ihr Konto wird gelöscht",
successBody: "Sie wurden abgemeldet. Wir haben begonnen, Ihre Daten zu löschen, und aktive Abos gekündigt. Doch anders entschieden? Kontaktieren Sie innerhalb von 30 Tagen den AssetWRX-Support.",
complianceNote: "Sie können die Löschung Ihres Kontos jederzeit direkt in der App beantragen, wie vom App Store und Google Play gefordert.",
cancel: "Abbrechen",
},
featureRequests: {
  editFirst: "Erst bearbeiten",
  helpRowTitle: "Funktion wünschen",
  helpRowSubtitle: "Sagen Sie uns, was AssetWRX für Sie besser machen würde.",
  myRequestsTitle: "Ihre Wünsche",
  myRequestsSubtitle: "Was Sie sich gewünscht haben und wo es steht.",
  myRequestsRowSubtitle_one: "{{count}} Wunsch gesendet",
  myRequestsRowSubtitle_other: "{{count}} Wünsche gesendet",
  myRequestsEmpty: "Sie haben noch keine Funktion gewünscht.",
  ideasTitle: "Ideen, die wir prüfen",
  ideasSubtitle: "Stimmen Sie für das, was Sie möchten. Wir sagen Ihnen, wenn sich etwas tut.",
  ideasRowSubtitle: "Stimmen Sie ab, was als Nächstes kommt.",
  ideasEmpty: "Gerade stehen keine Ideen zur Abstimmung.",
  ideasFooter: "Die Ideen hier schreibt das AssetWRX-Team. Ihre eigenen Wünsche bleiben privat.",
  loadFailed: "Das wurde nicht geladen. Prüfen Sie Ihre Verbindung und ziehen Sie nach unten, um es erneut zu versuchen.",
  sentOn: "Gesendet am {{date}} · {{category}}",
  mergedNote: "Jemand anderes hat sich das auch gewünscht, deshalb haben wir Ihren Wunsch damit zusammengeführt. Sie hören von uns, wenn sich etwas tut.",
  replyFromTeam: "Antwort vom AssetWRX-Team",
  seeWhatsNew: "Neuigkeiten ansehen: {{title}}",
  onIdeasBoard: "Auf der Ideenliste ansehen",
  vote: "Will ich auch",
  voted: "Abgestimmt",
  voteA11y: "Für {{title}} stimmen",
  unvoteA11y: "Stimme für {{title}} zurücknehmen",
  voteCount_one: "{{count}} Stimme",
  voteCount_other: "{{count}} Stimmen",
  voteFailedTitle: "Ihre Stimme wurde nicht gespeichert",
  voteFailedBody: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  status: {
    sent: "Gesendet",
    under_review: "Wird geprüft",
    planned: "Geplant",
    in_progress: "In Arbeit",
    shipped: "Jetzt in der App",
    not_planned: "Vorerst nicht geplant",
  },
  ideaStatus: {
    considering: "Wird geprüft",
    planned: "Geplant",
    in_progress: "In Arbeit",
    shipped: "Jetzt in der App",
  },
  category: {
    assets: "Assets und Orte",
    inspections: "Inspektionen und Checklisten",
    work: "Aufträge und Arbeit",
    schedules: "Zeitpläne",
    reports: "Berichte",
    team: "Team und Auftragnehmer",
    integrations: "Integrationen und API",
    other: "Etwas anderes",
  },
  importance: {
    nice_to_have: "Wäre schön",
    saves_time: "Würde mir Zeit sparen",
    blocking: "Ohne das kann ich nicht arbeiten",
  },
  errors: {
    daily_limit: "Sie haben heute 5 Wünsche gesendet. Bitte senden Sie den Rest morgen.",
    workspace_limit: "Ihr Arbeitsbereich hat heute 20 Wünsche gesendet. Bitte versuchen Sie es morgen erneut.",
    blocked: "Funktionswünsche sind für Ihr Konto ausgeschaltet. Wenden Sie sich an den Support, wenn das ein Fehler ist.",
    incomplete: "Geben Sie einen kurzen Titel ein und beschreiben Sie, was Sie brauchen.",
    screenshot: "Ein Screenshot wurde nicht hochgeladen. Entfernen Sie ihn oder versuchen Sie es erneut.",
    failed: "Ihr Wunsch wurde nicht gesendet. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  },
  form: {
    title: "Funktion wünschen",
    subtitle: "Sagen Sie uns, was Sie brauchen. Das AssetWRX-Team liest jeden Wunsch.",
    titleLabel: "Was hätten Sie gern?",
    titlePlaceholder: "Zum Beispiel: QR-Etikett für jeden Raum drucken",
    titleRequired: "Geben Sie einen kurzen Titel ein.",
    descriptionLabel: "Wie würde es Ihnen helfen?",
    descriptionPlaceholder: "Was möchten Sie tun, und was steht heute im Weg?",
    descriptionRequired: "Beschreiben Sie kurz, was Sie brauchen.",
    categoryLabel: "Welcher Teil der App?",
    categoryRequired: "Wählen Sie den Teil der App, um den es geht.",
    importanceLabel: "Wie wichtig ist es?",
    screenshotsLabel: "Bildschirmfotos (optional)",
    screenshotsHint: "Bis zu 3. Bitte keine persönlichen oder Kundendaten zeigen.",
    addScreenshot: "Screenshot hinzufügen",
    addScreenshotShort: "Hinzufügen",
    removeScreenshot: "Screenshot entfernen",
    photoPermissionTitle: "Zugriff auf Fotos erlauben",
    photoPermissionBody: "Um einen Screenshot hinzuzufügen, erlauben Sie AssetWRX in den Einstellungen Ihres Telefons den Zugriff auf Ihre Fotos.",
    similarTitle: "Sie haben sich schon etwas Ähnliches gewünscht",
    similarHint: "Wenn es dasselbe ist, können Sie es unter Ihre Wünsche verfolgen, statt es erneut zu senden.",
    detailsTitle: "Wird mit Ihrem Wunsch gesendet",
    detailsHint: "Das hilft uns zu verstehen, wo Sie waren. Sonst wird nichts aus Ihrem Arbeitsbereich gesendet.",
    detailApp: "App-Version",
    detailUpdate: "Update",
    detailDevice: "Gerät",
    detailLanguage: "Sprache",
    detailScreen: "Bildschirm",
    detailWorkspace: "Arbeitsbereich",
    detailWorkspaceValue: "Name und Tarif Ihres Arbeitsbereichs",
    send: "Wunsch senden",
    failedTitle: "Nicht gesendet",
    sentTitle: "Danke, ist angekommen",
    sentBody: "Wir lesen jeden Wunsch. Sie erhalten eine Benachrichtigung, wenn sich der Status ändert oder wir antworten.",
    seeYourRequests: "Ihre Wünsche ansehen",
    done: "Fertig",
  },
},
};
